import React, { ChangeEvent } from 'react';
import { BannerPlaceType, BannerUrlTarget } from '@api/graphql/types';

interface Props {
    name: string;
    value: BannerUrlTarget;
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: BannerPlaceType, name: string) => void;
}

interface State {
    value: BannerUrlTarget;
}

class BannerUrlTargetSelect extends React.Component<Props, State> {

    public state = {
        value: BannerUrlTarget._self,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <>
                <select
                    name={this.props.name}
                    value={this.state.value}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { this.props.onChangeHandler((e.currentTarget.value as BannerPlaceType), this.props.name); }}
                    className="form-control"
                >
                    <option value={BannerUrlTarget._self}>Azonos ablakban</option>
                    <option value={BannerUrlTarget._blank}>Új ablakban</option>
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default BannerUrlTargetSelect;



// WEBPACK FOOTER //
// ./src/components/Form/BannerUrlTargetSelect.tsx